export enum LinksView {
  SEARCH = 1,
  EDIT = 2,
}
